export default {
    methods: {
        buildSelectOptions(rawOptions) {
            let raw = rawOptions || [];
            if (!raw.length) raw = '';

            const finalize = (options) => {
                return options.map((item) => {
                    const baseLabel = item.label != null ? item.label : String(item.value ?? '');
                    const hasSublabel = !!item.sublabel;
                    const labelHtml = hasSublabel
                        ? `<div>${baseLabel}</div><div class="text-caption">${item.sublabel}</div>`
                        : baseLabel;
                    return {
                        ...item,
                        labelHtml,
                        html: true,
                    };
                });
            };

            if (typeof raw === 'string') {
                if (raw === 'yesno') {
                    return finalize([
                        { value: 'yes', label: 'Yes' },
                        { value: 'no', label: 'No' },
                    ]);
                }
                if (raw === 'oyesno') {
                    return finalize([
                        { value: 'yes', label: 'Yes' },
                        { value: 'no', label: 'No' },
                        { value: 'other', label: 'Other' },
                    ]);
                }
                if (raw === 'likert') {
                    return finalize([
                        { value: 1, label: 'Strongly Disagree' },
                        { value: 2, label: 'Disagree' },
                        { value: 3, label: 'Neutral' },
                        { value: 4, label: 'Agree' },
                        { value: 5, label: 'Strongly Agree' },
                    ]);
                }
                return finalize([
                    { value: true, label: 'True' },
                    { value: false, label: 'False' },
                ]);
            }

            const first = raw[0];
            if (first && typeof first === 'object') {
                if ('value' in first && 'label' in first) {
                    return finalize(raw);
                }
                if ('label' in first) {
                    return finalize(raw.map((item) => ({
                        ...item,
                        value: item.value != null ? item.value : item.label,
                        label: item.label,
                    })));
                }
                if ('value' in first) {
                    return finalize(raw.map((item) => ({
                        ...item,
                        value: item.value,
                        label: item.label != null ? item.label : String(item.value),
                    })));
                }
            }

            return finalize(raw.map((item) => ({
                value: item,
                label: String(item),
            })));
        },
    },
};